
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/country-pavilions",
      function () {
        return require("private-next-pages/world/country-pavilions.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/country-pavilions"])
      });
    }
  